import React from "react"
import { useTranslation } from "react-i18next"
import { Button, IconButton, SvgIcon } from "@mui/material"
import { ReactComponent as DownloadIcon } from "../icons/icon_download.svg"
import { downloadJobFiles, MultilangJob } from "src/services/api/document"
import { useSnackbar } from "src/providers/SnackbarProvider"
import { CardColor } from "../card/BrowserCard"

interface Props {
  job: MultilangJob
  iconOnly?: boolean
  color: "electricMint" | "gray"
}

const DownloadButton: React.FC<Props> = ({ job, iconOnly, color }) => {
  const { t } = useTranslation("common")
  const { snackbarShowMessage } = useSnackbar()

  const downloadResultFile = () =>
    downloadJobFiles(job).catch((e) => snackbarShowMessage(t("files.downloadError"), "error"))

  if (iconOnly) {
    return (
      <IconButton onClick={downloadResultFile} color="electricMint" sx={{ p: 1 }}>
        <SvgIcon component={DownloadIcon} inheritViewBox style={{ fontSize: "1.125rem" }} />
      </IconButton>
    )
  }

  return (
    <Button
      onClick={downloadResultFile}
      variant="contained"
      color={color}
      endIcon={<SvgIcon component={DownloadIcon} inheritViewBox />}
    >
      {t("download")}
    </Button>
  )
}

export default DownloadButton
